module.exports = __webpack_public_path__ + "static/img/955f2a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/index/业务办理广告@3x.png
// module id = 639
// module chunks = 2